'use client';
import Script from 'next/script';
import { useAdsStore } from '@/features/ads/internal/state/ads-slice';

export const PrebidLoader = () => {
  const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX || '';
  const setPbjsLoaded = useAdsStore((state) => state.setPbjsLoaded);
  const handleLoad = () => {
    setPbjsLoaded(true);
  };
  const handleError = (e: Event | ErrorEvent) => {
    setPbjsLoaded(false);
    console.error('Failed to load Prebid.js', e);
  };

  return (
    <Script
      src={`${assetPrefix}/scripts/prebid.js`}
      strategy='afterInteractive'
      onLoad={handleLoad}
      onError={handleError}
    />
  );
};
